import { SnackbarProvider as RawSnackbarProvider } from 'notistack'
import { FC, PropsWithChildren } from 'react'
import { ModalErrorSnack } from '../../__legacy__/components/AuthFlow/ErrorSnack'
import { ModalInfoSnack } from '../../__legacy__/components/AuthFlow/InfoSnack'
import { ModalSuccessSnack } from '../../__legacy__/components/AuthFlow/SuccessSnack'

export const SnackbarProvider: FC<PropsWithChildren> = ({ children }) => (
  <RawSnackbarProvider
    anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
    Components={{
      modalInfo: ModalInfoSnack,
      modalError: ModalErrorSnack,
      modalSuccess: ModalSuccessSnack
    }}
  >
    {children}
  </RawSnackbarProvider>
)
